import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ChangePasswordIcons from "../../Common/SvgIcons/HeaderIcons/ChangePasswordIcon";
import MailIcon from "../../Common/SvgIcons/HeaderIcons/MailIcon";
import MyProfileIcon from "../../Common/SvgIcons/HeaderIcons/MyProfileIcon";
import { lastLoginTimeActionHandler } from "../../../store/actions/actionHandlers/loginActionHandler";
import { lastLoginTimeAction } from "../../../store/actions/actionCreators/loginActionCreator";
import { NavLink } from "react-router-dom";
import classes from "./HeaderProfile.module.scss";
import { FormattedMessage } from "react-intl";

const HeaderProfile = ({ reference, headerProfileonClick }) => {
  const dispatch = useDispatch();
  const [userName, setUserName] = useState(null);
  const [profileHoverState, profileSethoverState] = useState(false);
  const [changePwdHoverState, changePwdSethoverState] = useState(false);
  const [emailHoverState, emailSethoverState] = useState(false);
  const PrimaryColor1 = JSON.parse(localStorage.getItem("themeData")).CustomData
    .PrimaryColor1;
  const tenantName = localStorage.getItem("tenantName");
  const firstName = localStorage.getItem("firstName");
  useEffect(() => {
    //console.log(tenantName);
    const userNameFromLocal = localStorage.getItem("userName");
    if (!!userNameFromLocal) {
      setUserName(userNameFromLocal);
    }
  }, [tenantName]);
  const loginState = useSelector((state) => state.loginReducer);
  const { lastLoginTime } = loginState;
  let dateObj = new Date(lastLoginTime + "Z");
  let lastLoginTimeString = dateObj.toString().replace(/GMT.*/g, "");
  // On mount, check if this is a page refresh.
  // App.js sets _pageHiding in sessionStorage on every pagehide event.
  // sessionStorage survives a refresh but is wiped on tab close, so:
  //   _pageHiding present  → page was refreshed → restore cached value, skip API
  //   _pageHiding absent   → fresh load after tab close or first login → call API
  useEffect(() => {
    const isRefresh = sessionStorage.getItem("_pageHiding") === "1";
    sessionStorage.removeItem("_pageHiding");

    if (isRefresh) {
      const cached = sessionStorage.getItem("_cachedLastLoginTime");
      if (cached) {
        dispatch(lastLoginTimeAction(cached));
      }
    } else {
      dispatch(lastLoginTimeActionHandler(lastLoginTime));
    }
  }, [dispatch]); // eslint-disable-line react-hooks/exhaustive-deps

  // Keep the sessionStorage cache up-to-date so refresh restores the real value.
  useEffect(() => {
    if (lastLoginTime) {
      try { sessionStorage.setItem("_cachedLastLoginTime", lastLoginTime); } catch (_) {}
    }
  }, [lastLoginTime]);

  const tenantType = localStorage.getItem("SecurityProviderName");

  return (
    <>
      <div ref={reference} className={classes.headerProfileMainDiv}>
        <h3>
          <FormattedMessage id="WELCOME_TEXT" /> , {firstName}
        </h3>
        <div className={classes.headerProfileLinksMainDiv}>
          <NavLink
            className={classes.profileInnerLinks}
            onMouseEnter={() => profileSethoverState(true)}
            onMouseLeave={() => profileSethoverState(false)}
            onClick={() => headerProfileonClick()}
            to={`/${tenantName}/userProfile/myProfile`}
            style={{
              backgroundColor: profileHoverState
                ? PrimaryColor1
                : "transparent",
              color: profileHoverState ? "#fff" : "#333333",
            }}
          >
            <MyProfileIcon fill={profileHoverState ? "#fff" : "#707070"} />{" "}
            <FormattedMessage id="MY_PROFILE_TEXT" />
          </NavLink>
          {!(tenantType == "aad" || tenantType == "SAML2") && (
            <NavLink
              className={classes.profileInnerLinks}
              onMouseEnter={() => changePwdSethoverState(true)}
              onMouseLeave={() => changePwdSethoverState(false)}
              onClick={() => headerProfileonClick()}
              to={`/${tenantName}/userProfile/changePassword`}
              style={{
                backgroundColor: changePwdHoverState
                  ? PrimaryColor1
                  : "transparent",
                color: changePwdHoverState ? "#fff" : "#333333",
              }}
            >
              <ChangePasswordIcons
                fill={changePwdHoverState ? "#fff" : "#707070"}
              />
              <FormattedMessage id="MY_PROFILE_CHANGE_PWD__TEXT" />
            </NavLink>
          )}
          <NavLink
            className={classes.profileInnerLinks}
            onMouseEnter={() => emailSethoverState(true)}
            onMouseLeave={() => emailSethoverState(false)}
            onClick={() => headerProfileonClick()}
            to={`/${tenantName}/userProfile/contactUs`}
            style={{
              backgroundColor: emailHoverState ? PrimaryColor1 : "transparent",
              color: emailHoverState ? "#fff" : "#333333",
            }}
          >
            <MailIcon fill={emailHoverState ? "#fff" : "#707070"} />{" "}
            <FormattedMessage id="CONTACTUS_HEADER" />
          </NavLink>
        </div>
        {/* {!(tenantType == "aad" || tenantType == "SAML2") && ( */}
        <div className={classes.lastVisitInfo}>
          {lastLoginTime
            ? `Last Visited : ${lastLoginTimeString}`
            : "Welcome! This is your first visit."}
        </div>
        {/* )} */}
      </div>
      <div className={classes.headerProfileLinksMainDivOpaqueLayer}></div>
    </>
  );
};

export default HeaderProfile;
